import React from "react";
import { Routes, Route} from "react-router-dom";
import ListUserQueryProject from "../Components/User Query Project/listUserQueryProject";
import ViewUserQueryProject from "../Components/User Query Project/viewUserQueryProject";

const UserQueryProjectRoutes = () => {
  return (
    <Routes>
      <Route
        path="/user_query_project"
        element={<ListUserQueryProject></ListUserQueryProject>}
      ></Route>
      <Route path="/user_query_project/view/:id" element={<ViewUserQueryProject> </ViewUserQueryProject>}></Route>
    </Routes>
  );
};

export default UserQueryProjectRoutes;